<template>
  <transition
    name="modal"
    appear
  >
    <div class="modal">
      <div class="modal__window modal__window--type02">
        <!-- 모달 헤드(top) -->
        <div class="modal__head">
          <h1
            v-for="(item, index) in steps"
            :key="`message_${index}`"
            class="title title--modal"
          >
            <template v-if="step.current == index">
              {{ message[step.current] }}
            </template>
          </h1>
          <div class="modal__progress">
            <div
              class="modal__progressbutton"
              :style="{ left: progressPointer + '%' }"
            >
              <button class="button button--percent button--primary">
                <span class="modal__percentage">{{ progress }}%</span>
              </button>
            </div>
          </div>
        </div>
        <!-- Begin Modal -->
        <!-- 프로젝트 제목 -->
        <Title 
          v-if="activateSteps[step.current] === steps[0]"
          :request="request"
          @next-step="next"
        />
        <!-- 프로젝트 업무유형 -->
        <WorkType
          v-if="activateSteps[step.current] === steps[1]"
          :request="request"
          @prev-step="prev"
          @next-step="next"
          @save-click="save"
        />
        <!-- 프로젝트 기간 -->
        <Period
          v-if="activateSteps[step.current] === steps[2]"
          :request="request"
          @prev-step="prev"
          @next-step="next"
          @save-click="save"
        />
        <!-- 디바이스 선택 -->
        <SupportDevice
          v-if="activateSteps[step.current] === steps[3]"
          :request="request"
          @prev-step="prev"
          @next-step="next"
          @save-click="save"
          @goto-step="goto"
        />
        <!-- 프로젝트 최적화 -->
        <Optimization
          v-if="activateSteps[step.current] === steps[4]"
          :request="request"
          @prev-step="prev"
          @next-step="next"
          @save-click="save"
        />
        <!-- 프로젝트 필수스킬-->
        <Skill
          v-if="activateSteps[step.current] === steps[5]"
          :request="request"
          @prev-step="prev"
          @next-step="next"
          @save-click="save"
          @goto-step="goto"
        />
        <!-- 프로젝트 파일업로드-->
        <AttachFiles
          v-if="activateSteps[step.current] === steps[6]"
          :request="request"
          @prev-step="prev"
          @next-step="next"
          @save-click="save"
        />
        <!-- 예산 -->
        <Budget
          v-if="activateSteps[step.current] === steps[7]"
          :request="request"
          @prev-step="prev"
          @next-step="next"
          @save-click="save"
        />
        <!-- 프로젝트 추가할말 -->
        <Comment
          v-if="activateSteps[step.current] === steps[8]"
          :request="request"
          @prev-step="prev"
          @next-step="next"
          @save-click="save"
        />
        <!-- 프로젝트 연락처 입력-->
        <Contact
          v-if="activateSteps[step.current] === steps[9]"
          :request="request"
          @prev-step="prev"
          @submit="fileUpload"
          @save-click="save"
        />
        <!-- 프로젝트  접수완료-->
        <Success
          v-if="activateSteps[step.current] === steps[10]"
          :request="request"
          @success="success"
          @close="closeModal('request')"
        />
        <!-- End Modal -->
        <!-- 모달 닫기 버튼 -->
        <div class="modal__close">
          <button 
            class="button button--function"
            @click="closeModal('request')"
          >
            <span class="hide">닫기</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import axios from 'axios'
import api from '../api/index.js'
import { isDeepEqual, duplicator } from '../modules/common.js'
import Title from './request/Title'
import WorkType from './request/WorkType'
import Period from './request/Period'
import SupportDevice from './request/SupportDevice'
import Optimization from './request/Optimization'
import Skill from './request/Skill'
import AttachFiles from './request/AttachFiles'
import Budget from './request/Budget'
import Comment from './request/Comment'
import Contact from './request/Contact'
import Success from './request/Success'


const getDateFormat = date => {
  const year = date.getFullYear()
  let month = (1 + date.getMonth())
  month = month >= 10 ? month : '0' + month
  let day = date.getDate()
  day = day >= 10 ? day : '0' + day
  return `${year}.${month}.${day}`
}

const DEFAULT_REQUEST = {
  title: '',
  workType: '',
  period: {
    start: null,
    end: null
  },
  supportDevice: {
    devices: []
  },
  optimization: {},
  attachFiles: {
    files: []
  },
  budget: '',
  skill: {
    skills: []
  },
  comment: {},
  contact: {},
  currentStep: 0
}

export default{
  name:'Modal',
  components:{
    Title,
    WorkType,
    Period,
    SupportDevice,
    Optimization,
    Skill,
    AttachFiles,
    Budget,
    Comment,
    Contact,
    Success,
  },
  data(){
    return {
      step: {
        current: 0,
        excludes: [],
      },
      steps: [
        'title',
        'workType',
        'period',
        'supportDevice',
        'optimization',
        'skill',
        'attachFiles',
        'budget',
        'comment',
        'contact',
        'success'
      ],
      request: duplicator(DEFAULT_REQUEST),
      saving: false,
      message: [
        '정확한 공수산정을 위해 프로젝트에 대해 알려주세요',
        '정확한 공수산정을 위해 프로젝트에 대해 알려주세요',
        '확정되지 않은 경우 건너뛰실수 있습니다',
        '임시저장을 통해 커피한잔 한 후에 이어서 작성 하실수 있습니다',
        '정확한 공수산정을 위해 프로젝트에 대해 알려주세요',
        '원하는 스킬이 없으면 직접 입력도 가능합니다',
        '참고 자료는 임시저장해도 보관되지 않습니다 ',
        '거의 다 왔습니다, 예산은 필수 선택 항목입니다',
        '앞서 입력하지 못한 내용이 있다면 작성해주세요',
        '마지막 입니다! 견적서를 받으실 담당자 성함과 연락처를 작성해주세요',
        '수고 하셨습니다!',
      ]
    }
  },
  computed: {
    activateSteps() {
      const steps = []
      this.steps.forEach(item => {
        if (this.step.excludes.indexOf(item) === -1) {
          steps.push(item)
        }
      })
      return steps
    },
    activateStepsLen() {
      return this.activateSteps.length
    },
    progress() {
      if (this.step.current) {
        return Math.round((this.step.current) / (this.activateStepsLen - 1) * 100)
      } else {
        return 0
      }
    },
    progressPointer() {
      const max = 94
      return this.progress <= max ? this.progress : max
    },
    savedRequest() {
      return this.$store.getters.request
    }
  },
  watch: {
    savedRequest: {
      immediate: true,
      deep: true,
      handler() {
        if (this.saving) {
          alert('저장 되었습니다.')
          this.saving = false
        }
      }
    }
  },
  created() {
    },
  mounted() {
    this.isLoadRequest()
  },
  methods:{
    closeModal(target) {
      if (!isDeepEqual(this.savedRequest, this.request)) {
        if(window.confirm('이어서 작성 할 수 있도록 작성중인 정보를 저장 하시겠습니까?')) {
          this.save()
        }
      }
      setTimeout(() => {
        this.$store.commit('modalOff', target)
      }, 1000)
    },
    next() {
      this.step.current++
    },
    prev() {
      this.step.current--
    },
    save() {
      this.saving = true
      this.request.currentStep = this.step.current
      this.$store.commit('request', duplicator(this.request))
    },
    init() {
      this.$store.commit('request', duplicator(DEFAULT_REQUEST))
    },
    isLoadRequest() {
      if (this.savedRequest.title) {
        if(window.confirm('작성중인 정보를 불러 오시겠습니까?')) {
          this.loadSavedRequest()
        } else {
          this.init()
        }
      } else {
        this.init()
      }
    },
    loadSavedRequest() {
      this.request = duplicator(this.savedRequest)
      this.step.current = this.request.currentStep
    },
    goto(pointer) {
      const index = this.steps.indexOf(pointer)
      if (index !== -1) {
        this.step.current = index
      }
    },
    fileUpload() {
      const files = this.request.attachFiles.files
      const filesString = []
      if (files) {
        if (files.length) {
          let uploadCount = 0
          //업로드
          for( var i = 0; i < files.length; i++ ){
            let formData = new FormData()
            let file = files[i]
            formData.append('attach', file)
            api.FileUpload(formData)
            .then(response => {
              console.log('done uploading', response)
              filesString.push(response.data.fileName)
              uploadCount++
              if (uploadCount === files.length) {
                this.requestSubmit(filesString)
              }
            })
            .catch(e => {
              console.log(e);
            });
          }
        } else {
          this.requestSubmit(filesString)
        }
      }
    },
    requestSubmit(filesString) {

      /*
        1. 파일이 있으면 업로드, 업로드 된 파일명 Request에 포함시킴
        2. 입력된 리퀘스트 정보 서버 전송
        3-1. 응답 결과가 정상이면 
          - this.request 초기화
          - Store 초기화
          - 다음 화면으로 이동
        3-2. 오류가 있다면 대기
      */
      
      let period = ''
      if (this.request.period.tbd) {
        period = 'TBD'
      } else {
        if (this.request.period.start && this.request.period.end) {
          if (typeof this.request.period.start === 'string') {
            this.request.period.start = new Date(this.request.period.start)
            this.request.period.end = new Date(this.request.period.end)
          }
          const start = getDateFormat(this.request.period.start)
          const end = getDateFormat(this.request.period.end)
          period = `${start} ~ ${end}`
        }
      }

      let optimization = ''
      if (this.request.optimization.tbd) {
        optimization = 'TBD'
      } else {
        optimization = this.request.optimization.type
      }

      let devices = ''
      if (this.request.supportDevice.tbd) {
        devices = 'TBD'
      } else {
        if (this.request.supportDevice.devices.length) {
          this.request.supportDevice.devices.forEach((device, index) => {
            const delimeter = index ? ',' : ''
            devices += `${delimeter} ${device}`
          })
        }
      }

      let skills = ''
      if (this.request.skill.tbd) {
        skills = 'TBD'
      } else {
        if (this.request.skill.skills.length) {
          this.request.skill.skills.forEach((item, index) => {
            const delimeter = index ? ',' : ''
            skills += `${delimeter} ${item}`
          })
        } 
      }

      const sendData = {
        name: this.request.contact.name,
        company: this.request.contact.company,
        email: this.request.contact.email,
        phone: this.request.contact.phone,
        message: this.request.comment.body,
        title: this.request.title,
        workType: this.request.workType,
        period: period,
        devices: devices,
        optimization: optimization,
        skill: skills,
        files: filesString.length > 0 ? filesString : 'TBD',
        budget: this.request.budget
      }
      
      api.RequestProject(sendData)
        .then(response => {
          if (response.data.status) {
            this.next()
          }
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {})
    },
    success() {
      this.init()
      this.$gtag.query('event', 'Request Success', {
        app_name: 'UILab Homepage',
        screen_name: 'Request Popup',
      })
      this.request = duplicator(DEFAULT_REQUEST)
    }
  },
}
</script>
<style lang="scss" scoped>
//Modal 공통요소 스타일
/*layout*/
.modal{
  $self:&;  
  &__progress{
    margin-top:15px;
    position:relative;
    width:100%;
    height:6px;
    background-color: #f1f1f1;
    border-radius: 2px;
  }
  &__progressbutton{
    position:absolute;
    top:-12px;
    left:0;
  }   
}

</style>